<div style='margin-right: 18px; position: relative; padding-top: 35px;'>
  <powerbi-report *ngIf="reportConfig.id" powerbi-type="report"
    [embedConfig]="reportConfig" [eventHandlers]="eventHandlers"
    style="height: 800px; width: 100%;"></powerbi-report>
</div>
<ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }"
  [template]="customLoadingTemplate">
</ngx-loading>
<ng-template #customLoadingTemplate>
  <div class="custom-class-loader">
    <div class="spinner-container">
      <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
    </div>
  </div>
</ng-template>